module.exports = __webpack_public_path__ + "img/cave89.26598976.jpg";